module.exports = __webpack_public_path__ + "img/customer.4ff67f87.svg";